import React, { useEffect, useState } from 'react';
import { Layout, Image } from 'antd';
import Information from "../component/Information";
import Introduction from "../component/Introduction";
import { getCandidateLogo } from '../../../controller/localStroageHandler';
const { Header, Content } = Layout;
const Detail = () => {
  const logo=getCandidateLogo()
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.keyCode === 27) {
        // Esc key
        event.preventDefault();
      }
      if (
        (event.ctrlKey || event.metaKey) &&
        (event.key.toLowerCase() === 'r' ||
          event.key.toLowerCase() === 'c' ||
          event.key.toLowerCase() === 's' ||
          event.key.toLowerCase() === 'x' ||
          event.key.toLowerCase() === 'n' ||
          event.key.toLowerCase() === 'f' ||
          event.key.toLowerCase() === 'tab')
      ) {
        event.preventDefault();
        console.log('prevent the tab and copy shortcut');
      }
      if ( event?.altKey) {
        event.preventDefault();
        console.log('prevent shift and alt key');
      }
      if (
        event.key &&
        event.key.startsWith('F') &&
        !isNaN(event.key.slice(1))
      ) {
        event.preventDefault();
        console.log('Function key press prevented');
      }
    };
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        console.log('visible');
      } else {
        console.log('hidden');
      }
    });
    const handleContextMenu = (event) => {
      event.preventDefault();
      console.log('Right-click context menu prevented');
    };
    document.addEventListener('keydown', handleKeyPress);
    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);
  const [current, setCurrent] = useState(0);
// eslint-disable-next-line
  const [formData,setFormData]=useState()
  const steps = [
    {
      title: '',
      content: <Information current={current} setCurrent={setCurrent} setFormData={setFormData} />,
    },
    {
      title: '',
      content: <Introduction current={current} setCurrent={setCurrent}  />,
    },
  ];
  return (
    <Layout className='w-100 h-100 test-details'>
      <Header className='bg-white border-2 border-bottom border-color h-auto pt-2 pb-2 header-custom'>
      <Image src={logo} className='logo' width={120} alt='' preview={false} />
      </Header>
      <Content className='h-100 w-100 bg-white'>
        <div className='steps-content h-100'>{steps[current].content}</div>
      </Content>
    </Layout>
  );
};

export default Detail;
